import React from "react";
import { Link } from "react-router-dom";

const JobsOttawa = () => {
  return (
    <>
      <section
        className="ptb-100 home-bannersection"
        style={{
          backgroundImage: "url('/assets/images/career-listbg.png')",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="banner-content">
                <span className="small-title">House Cleaner - Ottawa </span>
                <h1 className="banner-title">
                  <span>Attention Housekeepers –</span> Earn Up to $30/Hour with
                  MopForce!
                </h1>
                <div className="d-inline-flex mt-3">
                  <Link
                    to="/contractor-application"
                    className="success-orangebtn text-decoration-none"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="howitwork-section ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="introduction-contentDiv">
                <h2 className="main-title">Overview</h2>
                <p className="notification-graypara">
                  MopForce is among Canada’s fastest-growing cleaning services,
                  and we’re expanding our team of hardworking, reliable
                  housekeepers in Ottawa. If you enjoy meeting new
                  people, appreciate flexible hours, and like making homes
                  sparkle, we’d love to hear from you!
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="introductionimgDiv">
                <img
                  className="introduction-img img-fluid"
                  width="575"
                  height="365"
                  src="/assets/images/career.png"
                  alt="Introduction"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whyjoin-jobsection ptb-100">
        <div className="container">
          <div className="row align-items-center responsive-aboutrow">
            <div className="col-lg-12">
              <h2 className="main-title">Why Join MopForce? </h2>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-6">
              <div className="whyjoin-jobcard">
                <img
                  className="serviceclening-img"
                  src="/assets/images/Flexible Scheduling.png"
                  width="70"
                  height="70"
                  alt="Service Hours"
                  loading="lazy"
                ></img>
                <div>
                  <h3 className="medium-title">Flexible Scheduling  </h3>
                  <p className="mb-0 notification-graypara">
                    Need Mondays off? Prefer working around family commitments?
                    You decide when to accept appointments—no rigid timelines.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="whyjoin-jobcard">
                <img
                  className="serviceclening-img"
                  src="/assets/images/Variety Every Day.png"
                  width="70"
                  height="70"
                  alt="Service Hours"
                  loading="lazy"
                ></img>
                <div>
                  <h3 className="medium-title">Variety Every Day </h3>
                  <p className="mb-0 notification-graypara">
                    Meet new clients, clean different homes, and say goodbye to
                    dull or repetitive tasks. 
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="whyjoin-jobcard">
                <img
                  className="serviceclening-img"
                  src="/assets/images/Competitive Pay.png"
                  width="70"
                  height="70"
                  alt="Service Hours"
                  loading="lazy"
                ></img>
                <div>
                  <h3 className="medium-title">Competitive Pay </h3>
                  <p className="mb-0 notification-graypara">
                    Our top professionals can earn up to $30 per hour. We pay
                    within 48 hours of every shift completed, so you’re never
                    waiting long for your earnings.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="whyjoin-jobcard">
                <img
                  className="serviceclening-img"
                  src="/assets/images/Friendly Support.png"
                  width="70"
                  height="70"
                  alt="Service Hours"
                  loading="lazy"
                ></img>
                <div>
                  <h3 className="medium-title">Friendly Support </h3>
                  <p className="notification-graypara mb-0">
                    We handle directions, customer service, and payments,
                    leaving you free to focus on delivering quality cleans
                  </p>
                  <p className="notification-graypara mb-0">
                    —just pick your playlist and go.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="whyjoin-jobcard">
                <img
                  className="serviceclening-img"
                  src="/assets/images/What We're Looking For.png"
                  width="70"
                  height="70"
                  alt="Service Hours"
                  loading="lazy"
                ></img>
                <div>
                  <h3 className="medium-title">What We're Looking For</h3>
                  <ul className="whyjoin-ullist notification-graypara">
                    <li>
                      Prior housekeeping or cleaning experience is helpful but
                      not a must. 
                    </li>
                    <li>
                      Must have{" "}
                      <span style={{ fontWeight: "bold" }}>
                        reliable transportation.
                      </span>
                    </li>
                    <li>
                      Solid{" "}
                      <span style={{ fontWeight: "bold" }}>
                        verbal communication
                      </span>{" "}
                      skills
                    </li>
                    <li>
                      Ability to{" "}
                      <span style={{ fontWeight: "bold" }}>
                        pass a background check
                      </span>
                      .
                    </li>
                    <li>
                      Open to{" "}
                      <span style={{ fontWeight: "bold" }}>
                        full-time, part-time
                      </span>
                      , and <span style={{ fontWeight: "bold" }}>weekday</span>{" "}
                      scheduling options.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="lastdetails-section ptb-100"
        style={{ backgroundImage: "url('/assets/images/last-detailsbg.png')" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-9 col-md-12">
              <div className="about-contentDiv">
                <h2 className="main-title">Ready to Join MopForce? </h2>
                <p>You must apply online on our website to be considered: </p>
                <p>
                  We look forward to meeting you and helping you launch (or
                  grow) your housecleaning career!
                </p>
                <div className="d-inline-flex">
                  <Link
                    to="/contractor-application"
                    className="success-orangebtn text-decoration-none"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <img
          className="img-fluid last-details-shape"
          src="/assets/images/last-details-shapeimg.png"
          width="641"
          height="714"
          alt="Shape"
          loading="lazy"
        />
      </section>
    </>
  );
};

export default JobsOttawa;
